import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './components/views/Home.vue'
import Login from './components/views/Login.vue'
import NotFound from './components/views/NotFound.vue'
import store from './store'

Vue.use(VueRouter)

const requireAuth = (to, from, next) => {
  function proceed () {
    if (store.getters.getUserLoaded) {
      if (store.getters.getUser.loggedIn) {
        next()
      } else {
        next('/login')
      }
    }
  }

  if (!store.getters.getUserLoaded) {
    store.dispatch('loadUser').then(response => {
      proceed()
    })
  } else {
    proceed()
  }
}

export default new VueRouter({
  mode: 'history',
  base: `/${process.env.VUE_APP_SERVER_BASE}`,
  routes: [
    {
        path: '/',
        name: 'home',
        component: Home,
        beforeEnter (to, from, next) {
          next('/login')
        }
    },
    {
      path: '/offer/:id',
      name: 'offer',
      component: () => import(/* webpackChunkName: "manager" */ './components/views/offer/Offer.vue')
    },
    {
      path: '/manager',
      name: 'manager',
      component: () => import(/* webpackChunkName: "manager" */ './components/views/manager/Manager.vue'),
      children: [
        {
          path: 'companies',
          name: 'managerCompanies',
          component: () => import(/* webpackChunkName: "manager" */ './components/views/manager/CompanyList.vue')
        },
        {
          path: 'configuration',
          name: 'managerConfiguration',
          component: () => import(/* webpackChunkName: "manager" */ './components/views/manager/Configuration.vue')
        },
        {
          path: 'companies/company/:id',
          name: 'managerCompany',
          component: () => import(/* webpackChunkName: "manager" */ './components/views/manager/Company.vue')
        },
        {
          path: 'list',
          name: 'offer-list',
          component: () => import(/* webpackChunkName: "manager" */ './components/views/manager/OfferList.vue'),
          beforeEnter: requireAuth
        },
        {
          path: 'users',
          name: 'user-list',
          component: () => import(/* webpackChunkName: "manager" */ './components/views/manager/UserList.vue'),
          beforeEnter: requireAuth
        },
        {
          path: 'users/user/:id',
          name: 'user',
          component: () => import(/* webpackChunkName: "manager" */ './components/views/manager/User.vue'),
          beforeEnter: requireAuth
        }
      ],
      beforeEnter: requireAuth
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '*',
      name: '404',
      component: NotFound,
      beforeEnter (to, from, next) {
        // eslint-disable-next-line
        console.log(to)
        // eslint-disable-next-line
        console.log(from)
        // eslint-disable-next-line
        console.log(next)
        next()
      }
    }
  ],
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  }
})
